import { useEffect, useMemo, useState } from 'react'
import { debounce } from 'lodash'
import { AVAILABLE_DEVICE, MOBILE } from '@/common/constants/device'

const useWindowSize = () => {
  const [width, setWidth] = useState(0)

  const updateResizeWidth = debounce(() => {
    setWidth(document.documentElement.clientWidth)
  }, 100)

  useEffect(() => {
    window.addEventListener('resize', updateResizeWidth)
    setWidth(document.documentElement.clientWidth)

    return () => window.removeEventListener('resize', updateResizeWidth)
  }, [])

  const getDeviceName = useMemo(() => {
    return Object.keys(AVAILABLE_DEVICE).find((key) => {
      const minDeviceWidth = AVAILABLE_DEVICE[key].min
      const maxDeviceWidth = AVAILABLE_DEVICE[key].max

      if (key !== 'desktopL') {
        return width >= minDeviceWidth && width <= maxDeviceWidth
      }

      return minDeviceWidth >= width
    })
  }, [width])

  const isMobile = useMemo(() => {
    return getDeviceName === MOBILE
  }, [getDeviceName])

  return { device: getDeviceName, width: width, isMobile: isMobile }
}

export default useWindowSize
